
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/friendship",
      function () {
        return require("private-next-pages/friendship.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/friendship"])
      });
    }
  